import { usePersistedApiQuery } from 'common/query/usePersistedApiQuery';

import { fetchDashboards } from './api';

export const DASHBOARDS_QUERY_KEY = ['dashboards'] as const;

export function useDashboardsQuery({ enabled }: { enabled: boolean } = { enabled: true }) {
  return usePersistedApiQuery({
    queryKey: DASHBOARDS_QUERY_KEY,
    queryFn: () => fetchDashboards(),
    staleTime: Infinity,
    gcTime: 24 * 60 * 60 * 1000,
    refetchOnWindowFocus: false,
    enabled,
  });
}
